import React from "react";
import PropTypes from "prop-types";
import If from "../reusable/If/If.jsx";

// UnderwritingCriteria renders the underwriting-period figures (Days to Claim,
// Miles to Claim, Inspection Status) and the read-only chargeback selection in
// the whitespace to the right of the RO column, so the existing RO fields keep
// their width and alignment. The chargeback value is editable only on the
// chargeback window and mirrored here (TS-18343).
const UnderwritingCriteria = ({ claimObject }) => {
  const review = claimObject.underwriting_review || {};

  // Red X when the figure meets the underwriting criteria, green check when it
  // does not.
  const criteriaIcon = (meets) => (
    <i className={ `fa ${meets ? 'fa-times text-danger' : 'fa-check text-success'} ml-2` }
      aria-hidden="true"
      title={ meets ? 'Meets underwriting criteria' : 'Does not meet underwriting criteria' }/>
  );

  return (
    <section className="col">
      <div className="form-group row">
        <div className="col-12">
          <label className="col-form-label-sm font-weight-bold">Underwriting</label>
        </div>
      </div>
      <If condition={ review.days_to_claim_valid }>
        <div className="form-group row">
          <span className="col-12 col-form-label-sm text-nowrap" id="days-to-claim"
            title="Days to Claim (RO opened minus contract effective date)">
            Days to Claim: { review.days_to_claim }{ criteriaIcon(review.days_to_claim_meets) }
          </span>
        </div>
      </If>
      <If condition={ review.miles_to_claim_valid }>
        <div className="form-group row">
          <span className="col-12 col-form-label-sm text-nowrap" id="miles-to-claim"
            title="Miles to Claim (RO mileage minus contract mileage at sale)">
            Miles to Claim: { review.miles_to_claim }{ criteriaIcon(review.miles_to_claim_meets) }
          </span>
        </div>
      </If>
      <div className="form-group row">
        <span className="col-12 col-form-label-sm" id="inspection-status">
          Inspection Status{ criteriaIcon(review.inspection_meets) }
        </span>
      </div>
      <div className="form-group row">
        <div className="col-5">
          <label className="col-form-label-sm">Chargeback</label>
        </div>
        <span className="col-7 col-form-label-sm" id="underwriting-chargeback-value">
          { claimObject.underwriting_chargeback || review.underwriting_default }
        </span>
      </div>
    </section>
  );
};

UnderwritingCriteria.propTypes = {
  claimObject: PropTypes.object.isRequired,
};

export default UnderwritingCriteria;
